import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { PaymentExpectationApi } from 'further-types/payment';
import { InvestmentPaymentStatus } from 'further-types/investment';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

export default function useOutstandingPayments(params: {
  page: number;
  rowsPerPage: number;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
  paymentStatuses?: Array<InvestmentPaymentStatus>;
}) {
  return useQuery<PaymentExpectationApi.GetOutstandingPaymentsResponse>({
    queryKey: ['outstanding-payment-expectations', params],
    queryFn: async () =>
      (
        await api.get<
          ApiResponse<PaymentExpectationApi.GetOutstandingPaymentsResponse>
        >('/payment-expectation/outstanding', {
          params,
        })
      ).data.data,
    enabled: (params.paymentStatuses?.length ?? 0) > 0,
    placeholderData:
      (params.paymentStatuses?.length ?? 0) > 0 ? keepPreviousData : undefined,
    staleTime: QUERY_STALE_TIME_MS,
  });
}
